import { createSlice } from "@reduxjs/toolkit";
import { gettotalusersbyusertypeThunk, getdistrictsofstateThunk, getblocksofdistrictsThunk } from "./Users.Thunk";

const initialState = {
  data: [],
  filteredData: [],
  districts:[],
  blocks:[],
  loading: false,
  status: "",
  message: "",
  usertype: "manager",
};

const UsersSlice = createSlice({
  name: "usersslice",
  initialState,
  reducers: {
    searchtext_onchange(state, action) {
      state.filteredData = action.payload;
    },
    state_onchange(state, action) {
      state.districts = [];
      state.blocks = [];
    },
  },
  extraReducers: {
    [gettotalusersbyusertypeThunk.pending]: (state, action) => {
      state.data = [];
      state.filteredData = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [gettotalusersbyusertypeThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.filteredData = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [gettotalusersbyusertypeThunk.rejected]: (state, action) => {
      state.data = [];
      state.filteredData = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getdistrictsofstateThunk.pending]: (state, action) => {
      state.districts = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getdistrictsofstateThunk.fulfilled]: (state, action) => {
      state.districts = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getdistrictsofstateThunk.rejected]: (state, action) => {
      state.districts = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [getblocksofdistrictsThunk.pending]: (state, action) => {
      state.blocks = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getblocksofdistrictsThunk.fulfilled]: (state, action) => {
      state.blocks = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getblocksofdistrictsThunk.rejected]: (state, action) => {
      state.blocks = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const { searchtext_onchange, state_onchange } = UsersSlice.actions;

export default UsersSlice.reducer;
